// extracted by mini-css-extract-plugin
export default {"Wrapper":"ISDEIEHCDataExtractorCongrats_Wrapper__vBhZz","Buttons":"ISDEIEHCDataExtractorCongrats_Buttons__uis5v"};